import React, { useContext } from "react";
import PropTypes from "prop-types";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { Modal, Box } from "rbx";
import { TabLink, TabLinkIcon } from "../styles/StyledSectionHeader";

const defaultContext = {
  isModalOpen: false,
  modalContent: "",
  setModalOpen: (open = true) => ({ isModalOpen: open })
};

export const ModalContext = React.createContext(defaultContext);

export const ModalProvider = () => (
  <ModalContext.Consumer>
    {({ isModalOpen, modalContent, setModalOpen }) => (
      <Modal
        clipped
        closeOnEsc
        active={isModalOpen}
        onClose={() => setModalOpen(false, "")}
      >
        <Modal.Background />
        <Modal.Content
          style={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate3d(-50%, -50%, 0)"
          }}
        >
          <Box style={{ minWidth: "35vw" }}>{modalContent}</Box>
        </Modal.Content>
        <Modal.Close />
      </Modal>
    )}
  </ModalContext.Consumer>
);

ModalProvider.propTypes = {};

export const TabLinkModalTrigger = ({ icon, text, ModalContent }) => (
  <ModalContext.Consumer>
    {({ setModalOpen }) => (
      <TabLink
        onClick={() =>
          setModalOpen(true, <ModalContent setModalOpen={setModalOpen} />)
        }
      >
        <TabLinkIcon>
          <FontAwesomeIcon fixedWidth icon={icon} />
        </TabLinkIcon>
        <span>{text}</span>
      </TabLink>
    )}
  </ModalContext.Consumer>
);

TabLinkModalTrigger.propTypes = {
  icon: PropTypes.string,
  text: PropTypes.string,
  ModalContent: PropTypes.oneOfType([PropTypes.node, PropTypes.func])
};

export const useModal = () => useContext(ModalContext);

export default ModalProvider;
